import axios from "axios";
import { apiUrl } from "../../App";

export async function updateUserPhoneUseCase(id: string, variables: any) {
  return await axios.patch(`${apiUrl}/admin/users/${id}/phone`, variables, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
